import React, {Component} from 'react';
import {t, dt} from 'l10n';
import '../../sass/room.scss';

import ModalMyBobTVRoom from 'components/modals/ModalMyBobTVRoom';
import { localizeUrl } from 'components/ReactRouterDomLocalized';

import RoomUserListItem from './RoomUserListItem';

import {getRoomUserWeight, filterRoomUser} from '../../utils/user';
import {addHashParam as addURLHashParam, isSameRoomURL} from '../../utils/url';

import EnterIcon from "../icon/Enter"
import ExpandIcon from "../icon/Expand"
import CollapseIcon from "../icon/Collapse"

const MAX_USER_ITEMS_PERSONAL = 5;

class RoomItemPersonal extends Component {
    constructor(props) {
        super(props);

        let {room} = props;

        this.state = {
            expanded: this.isExpanded(room),
            showMyModal: false
        };

        this._onWindowResize = this._onWindowResize.bind(this);

        this.openRoomFn = this.openRoomFn.bind(this);
    }

    _onWindowResize(event) {
        // code
        this.forceUpdate();
    }

    componentDidMount() {
        window.addEventListener('resize', this._onWindowResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this._onWindowResize);
    }

    isExpanded(room) {
        /*
        if (room.personal) {
            return false;
        }
        */

        return true;
    }

    openRoomFn(event, url=null, user=null) {
        event.preventDefault();

        let {room} = this.props;
        let {showRoomIsFull} = this.state;

        let room_url = localizeUrl(url ? url : room.url);
        if(user) {
            room_url = addURLHashParam(room_url, "u", btoa(user.ufrag));
            if(user.roomid) room_url = addURLHashParam(room_url, "roomid", user.roomid);
        }

        if (!showRoomIsFull) {
            //window.open(localizeUrl(room_url), 'chat', 'height=678,width=1200,resizable=1,toolbar=0,scrollbars=0');
            this.maybeOpenRoom(room_url, 'chat', user ? user : room.creator);
        } else {
            this.setState({showRoomIsFullModal: true})
        }
    }

    maybeOpenRoom(url, windowname, user) {
        let wnd = window.open('', windowname, 'height=678,width=1200,resizable=1,toolbar=0,scrollbars=0');

        // if we just opened the window
        if (wnd.closed || (!wnd.document.URL) || (wnd.document.URL.indexOf("about") === 0) || !isSameRoomURL(url, wnd.document.URL)) {
            wnd.location.href = url;
        } else {
            wnd.focus();
            if(user) {
                wnd.postMessage({action: 'openVideoWindow', ufrag: user.ufrag, roomid: user.roomid}, "*");
            }
        }

        // return the window
        return wnd;
    }

    userFilterCallback(user) {
        let room = this;

        return filterRoomUser(user, room);
    }

    userSortCallback(user1, user2) {
        // the higher weighted user will be closer to sorted list's start
        return getRoomUserWeight(user1) > getRoomUserWeight(user2) ? -1 : 1;
    }

    getUserItemsPerRow() {
        let result = 5;
        let page_width;
        try {
            page_width = document.body.clientWidth;
        } catch (e) {
            return result;
        }

        if(page_width < 329) {
            result = 1;
        } else if(page_width < 679) {
            result = 2;
        } else if(page_width < 1197) {
            result = 3;
        } else if(page_width < 1504) {
            result = 4;
        }

        return result;
    }

    getMaxUserItems(room) {
        let result = MAX_USER_ITEMS_PERSONAL;

        let page_width;
        try {
            page_width = document.body.clientWidth;
        } catch (e) {
            return result;
        }

        if(page_width < 679) {
            result = 2;
        } else if(page_width < 1197) {
            result = 3;
        } else if(page_width < 1504) {
            result = 4;
        }

        return result;
    }


    render() {
        let {room} = this.props;
        
        let isShowroom = room.showroom_price ? room.showroom_price > 0 : false;
        let {expanded, showMyModal} = this.state;

        let visibleUsers = [];

        if (room.users && room.users.length) {
            visibleUsers = room.users
                .filter(this.userFilterCallback, room)
                .sort(this.userSortCallback)
                .slice(0, this.getMaxUserItems(room));
        }

        let visible_users_count = visibleUsers.length;
        let users_per_row = this.getUserItemsPerRow();
        let placeholder_count = 0;

        if(visible_users_count % users_per_row > 0) placeholder_count = users_per_row - visible_users_count % users_per_row;

        var placeholder_set = [];
        for (var i=0; i < placeholder_count; i++) {
            placeholder_set.push(<div key={"ph" + i} className="stretch-wrapper no-border"><a href={room.url} onClick={this.openRoomFn} title={room.name}></a></div>);
        }

        let roomEditable = false;

        let openRoomButtonClasses = ['open-room'];
        openRoomButtonClasses.push(room.active ? 'active' : 'inactive');

        let onOpenRoomClick = room.active ? this.openRoomFn : null;

        let classNames = ['room-item', 'neo', 'my'];
        if (expanded) classNames.push('expanded');

        return (
            <div className={classNames.join(' ')}>
                <div className="content">
                    <div className="top">
                        <div className="left-top">
                            <div className="left-top-inner">
                                <div className="author-img"><a href={room.creator.profile_url}><img src={room.creator.avatar_url} alt={room.creator.nick} /></a></div>
                                <span className="title-prefix"><a href={room.creator.profile_url}>{room.creator.nick}</a></span>
                                {isShowroom ? <span className="room-name-my room-showroom" title={room.name}></span> : null }
                                <span className="room-name-my" title={room.name}>{room.name}</span>
                            </div>
                        </div>
                        <div className="right-top">
                            <div>
                                {roomEditable ? <div className="edit-room" onClick={() => this.setState({showMyModal: true})}/> : <div></div>}
                                <div className="people">{room.userCount || 0}</div>
                            </div>

                            {showMyModal && <ModalMyBobTVRoom show={true} closeFn={() => this.setState({showMyModal: false})} room={room}/>}

                            <a
                                href={room.active && room.url}
                                className={openRoomButtonClasses.join(' ')}
                                onClick={onOpenRoomClick}
                            >
                                <EnterIcon colorIndex="theme" hoverColorIndex="white"/>
                                <span className="big-screen">{t('Open this room')}</span>
                                <span className="small-screen">{t('Open')}</span>
                            </a>

                        </div>
                        <div className="expand"><div className="expand-control" onClick={() => this.setState({expanded: !expanded})}>
                            {expanded ? <CollapseIcon colorIndex="theme"/> :
                                            <ExpandIcon colorIndex="theme"/>}
                        </div></div>
                    </div>
                    <div className="snapshot-list">
                        {visibleUsers.map((user, index) =>
                            <RoomUserListItem key={index} user={user} room={room} roomUrl={room.url} onItemClick={onOpenRoomClick}/>
                        )}
                        {placeholder_set}
                    </div>
                </div>
            </div>
        )
    }
}

export default RoomItemPersonal;


// WEBPACK FOOTER //
// ./src/components/index/RoomItemPersonal.js